import { CartSheet, Footer, Header, SEO } from '@/components';
import { About } from './sections/about';
import { BuffaloSection } from './sections/buffalo';
import { Contact } from './sections/contact';
import { Hero } from './sections/hero';
import { Metrics } from './sections/metrics';
import { NewDrones } from './sections/newDrones';
import { PartsSection } from './sections/parts';
import { PowerCitrosSection } from './sections/power-citros';
import { Spraying } from './sections/spraying';
import { UsedDrones } from './sections/usedDrones';

export function Home() {
  return (
    <div className="min-h-screen">
      <SEO
        title="Drones Profissionais e Assistência Técnica para Drones Agrícolas"
        description="Especialistas em drones profissionais e assistência técnica para drones agrícolas. Oferecemos tecnologia de ponta, manutenção especializada e soluções personalizadas para maximizar a produtividade do seu negócio."
        keywords="drones profissionais, assistência técnica drones, manutenção drones agrícolas, agricultura de precisão, drones para agricultura, drones novos, drones usados"
      />
      <Header />

      <main>
        {/* Hero Section */}
        <Hero />

        {/* New Drones Section */}
        <NewDrones />

        {/* Used Drones Section */}
        <UsedDrones />

        {/* Buffalo Line Section */}
        <BuffaloSection />

        {/* Power Citros Section */}
        <PowerCitrosSection />

        {/* Parts Section */}
        <PartsSection />

        {/* Technical Assistance and Maintenance Section */}
        <Spraying />

        {/* About Section */}
        <About />

        {/* Metrics Section */}
        <Metrics />

        {/* Contact Section */}
        <Contact />
      </main>

      <Footer />
      <CartSheet />
    </div>
  );
}
